// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___mcSd","question":"styles_question__l3peh","description":"styles_description__Uc7xe"};